<ng-container *transloco="let t; prefix: 'identity.change-password'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="form" (ngSubmit)="submit()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            @if (errorMessage(); as messageKey) {
              <app-inline-alert severity="danger" [message]="t('errors.' + messageKey)" />
            }

            <ion-item lines="none">
              <ion-input
                type="password"
                [label]="t('current-password')"
                labelPlacement="stacked"
                formControlName="currentPassword"
                autocomplete="current-password"
              >
                @if (authService.isNativeAppStoreBuild()) {
                  <ion-input-password-toggle slot="end" />
                }
              </ion-input>
            </ion-item>

            <ion-item lines="none">
              <ion-input
                type="password"
                [label]="t('new-password')"
                labelPlacement="stacked"
                formControlName="newPassword"
                autocomplete="new-password"
              >
                @if (authService.isNativeAppStoreBuild()) {
                  <ion-input-password-toggle slot="end" />
                }
              </ion-input>
            </ion-item>
            <p class="text-sm text-primary-text-light">{{ t('min-length-hint', { min: minPasswordLength }) }}</p>

            <ion-item lines="none">
              <ion-input
                type="password"
                [label]="t('confirm-password')"
                labelPlacement="stacked"
                formControlName="confirmPassword"
                autocomplete="new-password"
              >
                @if (authService.isNativeAppStoreBuild()) {
                  <ion-input-password-toggle slot="end" />
                }
              </ion-input>
            </ion-item>

            @if (showValidationErrors()) {
              <app-inline-alert severity="danger" [message]="t('validation-summary')" />
            }
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 flex-col gap-3 border-t border-primary-border px-4 py-4">
        <app-button type="submit" variant="primary" [fullWidth]="true" [loading]="submitting()">
          {{ t('submit') }}
        </app-button>
        <app-button
          type="button"
          variant="outline"
          [fullWidth]="true"
          [disabled]="submitting()"
          (clicked)="cancel()"
        >
          {{ t('cancel') }}
        </app-button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
